import React from "react";
import Hospitality_Banner from "./hospitality_banner/Hospitality_Banner";
import LuxuryFeatures from "./luxury_features/Luxury_Features";
import Comfort_Guage from "./comfort-guage/Comfort_Guage";
import Mattress from "./inside_the_matress/Inside_The_Matress";
import Matress_Description from "./matress_description/Matress_Description";
import Compatibility from "./compatibility/Compatibility";
import Luxury_Benefit_Of_Bliss from "./luxury_benefit_of_bliss/Luxury_Benefit_Of_Bliss";
import Inside_The_Matress from "./inside_the_matress/Inside_The_Matress";

function Hospitality() {
  return (
    <>
      <Hospitality_Banner />
      <Luxury_Benefit_Of_Bliss />
      <LuxuryFeatures />
      <Comfort_Guage />
      <Inside_The_Matress />

      <Matress_Description />
      <Compatibility />
    </>
  );
}

export default Hospitality;
